import { RouterLink, RouterLinkActive } from '@angular/router';
import { Component, TemplateRef, inject } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@app/core/services/auth.service';
import { versionInfo } from '../../../../version';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  host: { '(window:resize)': 'resize()' }
})
export class NavbarComponent {
  private _authService = inject(AuthService);
  private _offcanvasService = inject(NgbOffcanvas);

  userName = this._authService.UserName;

  open(content: TemplateRef<unknown>) {
    this._offcanvasService.open(content);
  }

  resize() {
    if (this._offcanvasService.hasOpenOffcanvas() && window.innerWidth >= 992) {
      this._offcanvasService.dismiss();
    }
  }

  logout() {
    this._authService.logout().subscribe(() => {
      this._offcanvasService.dismiss();
    });
  }

  get version(): string | null {
    return versionInfo.version !== 'VERSION_PLACEHOLDER' ? versionInfo.version : null;
  }

  get commit(): string {
    return versionInfo.commit !== 'COMMIT_PLACEHOLDER' ? versionInfo.commit : '';
  }
}
